import type { StudentLearningProfile } from '@/entities/profile/types'
import type { StudentIdentity } from '@/entities/student/types'
import type { PretestResult } from './types'

export function createInitialProfile(
  identity: StudentIdentity,
  result: PretestResult,
): StudentLearningProfile {
  const validScores = Object.values(result.ability).filter((item) => item.sampleCount > 0)
  const averageConfidence = validScores.length === 0
    ? 0
    : validScores.reduce((sum, item) => sum + item.confidence, 0) / validScores.length

  return {
    identity,
    ability: result.ability,
    preference: result.preference,
    knowledgePoints: result.knowledgePoints,
    pretestScore: result.score,
    recommendedLevel: result.recommendedLevel,
    confidence: Number(averageConfidence.toFixed(2)),
    version: 3,
    updatedAt: result.completedAt,
  }
}
